import { render, staticRenderFns } from "./FreezingSearch.vue?vue&type=template&id=7136b3e4&"
import script from "./FreezingSearch.vue?vue&type=script&lang=js&"
export * from "./FreezingSearch.vue?vue&type=script&lang=js&"
import style0 from "./FreezingSearch.vue?vue&type=style&index=0&id=7136b3e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports